<!-- 首页 -->
<template>
  <div class="e_robot">
    <div class="styleBox_01">
      <div>
        <img :src="baseImgUrl + '/u/20230206/icon_02_1675678837403.png'" />
        <strong>High safety</strong>
        <p>Asset stealth</p>
        <p>Zero Trust Security</p>
        <p>Security backup of the boundary itself</p>
      </div>
      <div>
        <img :src="baseImgUrl + '/u/20230206/icon_03_1675678837406.png'" />
        <strong>High availability</strong>
        <p>High resiliency and network automation orchestration</p>
        <p>Automated operation and maintenance</p>
        <p>Network level distributed traffic management</p>
        <p>High SLA infrastructure and control center</p>
      </div>
      <div>
        <img :src="baseImgUrl + '/u/20230206/icon_01_1675678837399.png'" />
        <strong>high-performance</strong>
        <p>Network self-healing management</p>
        <p>remote diagnosis</p>
        <p>Convenient access control</p>
        <p>Automatic notification and alarm</p>
      </div>
      <div>
        <img :src="baseImgUrl + '/u/20230206/icon_04_1675678837409.png'" />
        <strong>Highly manageable</strong>
        <p>Network self-healing management</p>
        <p>remote diagnosis</p>
        <p>Convenient access control</p>
        <p>Automatic notification and alarm</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      baseImgUrl: ''
    }
  },
  methods: {
  },
  created () {
  },
  mounted () {
    this.baseImgUrl = this.$axios.defaults.baseURL
  },
  computed: {
  }
}
</script>
<style lang="less" scoped>
// pc端样式
@media only screen and (min-width: 1024px) {
  .styleBox_01 {
    max-width: 1180px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 125px;
  }

  .styleBox_01 div {
    width: 23.72%;
    box-shadow: 0px 2px 12px 0px rgba(204, 204, 204, 0.5);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 46px 15px 76px 15px;
    margin: 0 1%;
    cursor: pointer;
  }

  .styleBox_01 div img {
    width: 60px;
    height: 60px;
    margin-bottom: 24px;
    transition: all 1s;
    -moz-transition: all 1s;
    -webkit-transition: all 1s;
    -o-transition: all 1s;
  }
  .styleBox_01 div:hover {
    transform: scale(1.1);
  }
  .styleBox_01 div strong {
    font-size: 20px;
    font-weight: 600;
    color: #353535;
    line-height: 28px;
    margin-bottom: 16px;
  }

  .styleBox_01 div p {
    font-size: 16px;
    font-weight: 400;
    color: #4c5461;
    line-height: 25px;
    text-align: center;
  }
}
// 移动端样式
@media only screen and (max-width: 1024px) {
  .styleBox_01 {
    max-width: 1180px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 1rem;
    flex-wrap: wrap;
    padding: 0 1rem;
    box-sizing: border-box;
  }

  .styleBox_01 div {
    width: 47%;
    box-shadow: 0px 2px 12px 0px rgba(204, 204, 204, 0.5);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2.25rem 0;
    margin: 0 1%;
    cursor: pointer;
    margin-bottom: 1.25rem;
  }

  .styleBox_01 div img {
    width: 3.125rem;
    height: 3.125rem;
    margin-bottom: 1rem;
    transition: all 1s;
    -moz-transition: all 1s;
    -webkit-transition: all 1s;
    -o-transition: all 1s;
  }
  .styleBox_01 div:hover {
    transform: scale(1.1);
  }
  .styleBox_01 div strong {
    font-size: 0.9375rem;
    font-weight: 600;
    color: #353535;
    line-height: 1.31rem;
    margin-bottom: 0.875rem;
  }

  .styleBox_01 div p {
    font-size: 0.875rem;
    font-weight: 400;
    color: #4c5461;
    line-height: 1.6rem;
    margin: 0;
    width: 80%;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comForPc/English_model/E_robotization.vue